const translations = {
  "en": {
    "Confirm": "Confirm",
    "Here's what I'll watch for you.": "Here's what I'll watch for you.",
    "Meet Ed": "Meet Ed",
    "Save this setup": "Save this setup",
    "Save this Setup": "Save this Setup",
    "These run quietly. I only ping you when something matters.": "These run quietly. I only ping you when something matters.",
    "Trackers I'll run": "Trackers I'll run"
  },
  "zh-tw": {
    "Confirm": "確認",
    "Here's what I'll watch for you.": "我會幫你盯著這些。",
    "Meet Ed": "認識 Ed",
    "Save this setup": "儲存此設定",
    "Save this Setup": "儲存此設定",
    "These run quietly. I only ping you when something matters.": "這些會靜靜運作。只有在有重要的事時我才會通知你。",
    "Trackers I'll run": "我會執行的追蹤"
  }
};

export default translations;
